import React from 'react';
import { FadeZoom } from './fadezoom';
import { defaultProps, SlideshowRef, ZoomProps } from './types';

export const Zoom = React.forwardRef<SlideshowRef, ZoomProps>((props, ref) => {
    return <FadeZoom {...defaultProps} {...props} ref={ref} />;
});
